import { render, staticRenderFns } from "./BaseArrowLeftIcon.vue?vue&type=template&id=36d033f4"
import script from "./BaseArrowLeftIcon.vue?vue&type=script&lang=js"
export * from "./BaseArrowLeftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports